import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { readStorage, writeStorage } from '@/lib/storage';
import en from './en';
import fr from './fr';

export const SUPPORTED_LOCALES = ['fr', 'en'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const NAMESPACES = [
  'common',
  'nav',
  'auth',
  'dashboard',
  'analytics',
  'search',
  'reports',
  'customers',
  'reservations',
  'users',
  'roles',
  'audit',
  'settings',
  'profile',
  'resources',
  'calendar',
  'availability',
  'maintenance',
  'documents',
  'compliance',
  'housekeeping',
  'tasks',
  'billing',
  'payments',
  'cash',
  'expenses',
  'taxes',
  'errors',
] as const;

const LOCALE_STORAGE_KEY = 'sa.locale';

export function readStoredLocale(): SupportedLocale {
  const stored = readStorage(LOCALE_STORAGE_KEY);
  return SUPPORTED_LOCALES.includes(stored as SupportedLocale) ? (stored as SupportedLocale) : 'fr';
}

export function storeLocale(locale: SupportedLocale): void {
  writeStorage(LOCALE_STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

void i18n.use(initReactI18next).init({
  resources: { fr, en },
  lng: readStoredLocale(),
  fallbackLng: 'fr',
  supportedLngs: SUPPORTED_LOCALES,
  ns: NAMESPACES,
  defaultNS: 'common',
  // Les valeurs sont déjà échappées par React.
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
